// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ytB8e1eK_8_NpvW0vAp0 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: inherit;
  text-overflow: inherit;
  overflow: inherit
}
.ytB8e1eK_8_NpvW0vAp0 > *:first-child {
    margin-right: 0.75rem;
    max-width: 1rem;
    min-width: 1rem;
  }
`, "",{"version":3,"sources":["webpack://./src/components/SelectHeaderValue/SelectHeaderValue.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB;AAOF;AALE;IACE,qBAAkB;IAClB,eAAe;IACf,eAAe;EACjB","sourcesContent":[".selectHeaderValueWithIcon {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  white-space: inherit;\n  text-overflow: inherit;\n  overflow: inherit;\n\n  & > *:first-child {\n    margin-right: 12px;\n    max-width: 16px;\n    min-width: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectHeaderValueWithIcon": `ytB8e1eK_8_NpvW0vAp0`
};
export default ___CSS_LOADER_EXPORT___;
